<template>
  <v-card
		:loading =loading
    class="mx-auto my-12"
    max-width="374"
  >
    <v-img
			width="350"
      height="250"
      :src="item.photo_url"
    ></v-img>

    <v-card-title>{{ item.name }}</v-card-title>

    <v-card-text>

      <div class="my-4 subtitle-1">
        {{ item.description }}
      </div>
      <div class="my-4 subtitle-1">
        {{ item.description1 }}
      </div>
      <div class="my-4 subtitle-1">
        {{ item.description2 }}
      </div>

    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-title>Alérgenos</v-card-title>

    <v-card-text>
      <v-chip-group
        active-class="deep-purple accent-4 white--text"
        column
      >

			<!-- /////////////////// -->

			<chip v-for="aler in  item.alergenos" :key="aler.id" class="px-2">
				<img :src="`/static/alergenos/${aler}.jpg`" />
			</chip>

			<!-- /////////////////// -->

      </v-chip-group>
    </v-card-text>
  </v-card>
</template>



<script>
	import {db} from '@/main';
  export default {
		name: 'ItemShow',
    data: () => ({
			item: {},
			alergenos: [],
      loading: true,
      selection: 1,
    }),
		created(){
			const refItem = db.collection('bussiness').doc('1').collection('items').doc('6m7KicAMLNj3v5s0qZG4')
			this.item = {}
			refItem.get().then( (doc) => {
				this.item = doc.data()
				this.loading = false			
			})
				
		},

  }
</script>
